export class PromoOrderAmounts {
   constructor(subtotal, subtotal_order_lines, ieps, iva, tax, after_tax_total, discount, final_total){
      this.subtotal = subtotal
      this.subtotal_order_lines = subtotal_order_lines
      this.ieps = ieps
      this.iva = iva
      this.tax = tax
      this.after_tax_total = after_tax_total
      this.discount = discount
      this.final_total = final_total
   }
}